import React from 'react'
import { humanize } from '@ztechapps/common.utils'
import { LoadingContent } from '@ztechapps/webui.util'

export type FeatureFlagLoadingProps = {
  featureName?: string
}

export const FeatureFlagLoading = ({ featureName = 'feature' }: FeatureFlagLoadingProps) => {
  return (
    <LoadingContent
      message="Loading Feature"
      subMessage={
        <span>
          Please wait while we are loading the <b>{humanize(featureName)}</b>...
        </span>
      }
    />
  )
}
